/* libs */
import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import moment from "moment";
import parseAppKey from "../../helpers/routeHelpers/parseAppKey";
import firebase from "firebase";
import FileUploader from "react-firebase-file-uploader";
import * as globalActions from "../../actions/globalActions";
import Loader from "./Loader";
import MediaItem from "./MediaItem";

class FileManager extends Component {
	constructor(props) {
		super(props);
		this.state = {
			minimizePlaceholder: false,
			value: "",
			isUploading: false,
			progress: 0,
			existingFiles: null,
			showFileManager: false,
			appId: null,
		};
		this.uploadButton = React.createRef();
	}

	shouldComponentUpdate(nextProps) {
		if (!this.props.apps && nextProps.apps) {
			let appId = nextProps.apps.find(app => app.key === parseAppKey()).id;
			this.setState({ appId }, () => {
				this.getExistingFiles();
			});
		}
		return true;
	}

	componentDidMount() {
		if (this.props.apps) {
			let appId = this.props.apps.find(app => app.key === parseAppKey()).id;
			this.setState({ appId }, () => {
				this.getExistingFiles();
			});
		}
	}

	handleUploadStart = () => {
		this.setState({ isUploading: true, progress: 0 });
	};

	handleProgress = progress => {
		this.setState({ progress });
	};

	handleUploadError = error => {
		this.setState({ isUploading: false });
		if (this.props.uploadError) {
			this.props.uploadError(error);
		}
	};

	handleUploadSuccess = fileName => {
		this.setState({ avatar: fileName, progress: 100, isUploading: false });
		firebase
			.storage()
			.ref(this.state.appId)
			.child(fileName)
			.getDownloadURL()
			.then(url => {
				let cdnUrl = `https://media.verrisapp.com/${this.state.appId}/${fileName}`;
				let db = firebase.firestore();
				let docRef = db.collection("image-data").doc(this.state.appId);
				let objectToUpsert = {
					data: [],
				};
				docRef
					.get()
					.then(doc => {
						if (doc.exists) {
							objectToUpsert.data = doc.data().data.concat();
						}
						let object = {
							fileName,
							url,
							cdnUrl,
							uses: 1,
							createdAt: new Date().getTime(),
						};
						objectToUpsert.data.push(object);
						this.props.actions.upsertFirebaseObject("image-data", this.state.appId, objectToUpsert);
					})
					.catch(function(error) {
						console.warn("File not added to Firebase records:", error);
					});
				if (this.props.uploadSuccess) {
					this.props.uploadSuccess(cdnUrl);
				}
			});
	};

	removeFile = event => {
		if (this.props.removeFile) {
			this.props.removeFile(event);
		}
	};

	selectExisting = () => {
		let { selectedUrl } = this.state;
		this.hideFileManager();
		if (this.props.uploadSuccess) {
			this.props.uploadSuccess(selectedUrl);
		}
	};

	getExistingFiles = async () => {
		var db = firebase.firestore();
		var docRef = db.collection("image-data").doc(this.state.appId);
		let doc = await docRef.get();
		if (doc.exists) {
			let existingFiles = doc.data().data.concat();
			this.setState({ existingFiles });
		}
	};

	getFile = (existingFiles, name) => {
		let existing = existingFiles.find(f => name === f.fileName);
		return existing;
	};

	fileNamer = file => {
		let name = file.name;
		let nameExists = true;
		let { existingFiles } = this.state;
		let index = 0;
		if (existingFiles) {
			while (nameExists) {
				let existing = this.getFile(existingFiles, name);
				if (existing) {
					//Warn user
					let parts = file.name.split(".");
					parts[0] = `${parts[0]}-${index}`;
					name = parts.join(".");
					index++;
				} else {
					nameExists = false;
				}
			}
		}
		if (name !== file.name) {
			alert(`${file.name} already exists, so we'll rename your new file`);
		}

		return name;
	};

	chooseExisting = event => {
		event.stopPropagation();
		event.preventDefault();
		this.setState({ showFileManager: true });
	};

	hideFileManager = () => {
		this.setState({ showFileManager: false });
	};

	getRealUrl = file => {
		return "cdnUrl" in file ? file.cdnUrl : file.url;
	};

	deleteFile = file => {
		const files = this.state.existingFiles;
		const index = files.findIndex(f => f.fileName === file.fileName && f.hidden !== true);
		files[index] = Object.assign({}, file, { hidden: true });
		this.props.actions.upsertFirebaseObject("image-data", this.state.appId, { data: files });
		this.setState({ existingFiles: files });
	};

	selectFile = url => {
		this.setState({ selectedUrl: url }, this.selectExisting);
	};

	renderFileList = () => {
		let { existingFiles } = this.state;
		if (!existingFiles) {
			return (
				<div className="file-manager-window relative">
					<div className="absolute-center ta-center">
						<h2>No Files</h2>
					</div>
				</div>
			);
		}
		existingFiles.sort(function(a, b) {
			var nameA = a.fileName.toLowerCase(),
				nameB = b.fileName.toLowerCase();
			if (nameA < nameB)
				//sort string ascending
				return -1;
			if (nameA > nameB) return 1;
			return 0; //default return value (no sorting)
		});
		return (
			<div className="0">
				<div className="file-list">
					{
						//<div>Search Here:</div>
						//<div>Folders Here</div>
					}
					{existingFiles
						.filter(f => f.hidden !== true)
						.map(file => {
							let failsafeUrl = this.getRealUrl(file);
							return (
								<div key={file.createdAt}>
									<MediaItem
										file={file}
										url={failsafeUrl}
										deleteFile={this.deleteFile}
										selectFile={this.selectFile}
									/>
								</div>
							);
						})}
				</div>
			</div>
		);
	};

	render() {
		const { value, error, placeholder, isRequired } = this.props;
		const isFocused = value && value.length > 0 ? " focus" : "";
		const hasError = error ? " has-error" : "";
		let imagePreviewStyle = {};
		let displayText = "";
		if (value) {
			imagePreviewStyle = { backgroundImage: `url(${value.replace(/\(/g, "%28").replace(/\)/g, "%29")})` };
			let parts = decodeURIComponent(value).split("/");
			displayText = parts[parts.length - 1].split("?")[0];
		}
		if (!this.state.appId) {
			return <Loader />;
		}
		return (
			<Fragment>
				<div
					className={`coverall global-coverall more ${this.state.showFileManager ? "on" : ""}`}
					onClick={() => this.hideFileManager()}
				></div>
				<div className={`file-picker-modal ${this.state.showFileManager ? "on" : "off"}`}>
					{this.state.showFileManager && this.renderFileList()}
				</div>
				<label className="upload-label" ref={this.uploadButton}>
					<div className={`input-wrap upload-wrap${isFocused}${hasError}`}>
						<div className="row m-0">
							<div className="col-sm-3 p-0">
								<div
									className={`upload-image-preview m-right ${value ? "on" : ""}`}
									style={imagePreviewStyle}
								>
									<div className="upload-icon">
										<i className="fal fa-file-upload"></i>
									</div>
									<div
										className="image-remove"
										onClick={event => {
											this.removeFile(event);
										}}
									>
										<i className="fal fa-times-circle"></i>
									</div>
								</div>
							</div>
							<div className="col-sm-9 p-0">
								<div className="btn btn-primary wide">Upload</div>
								<div className="btn btn-secondary wide m-top" onClick={this.chooseExisting}>
									Choose Existing
								</div>
							</div>
						</div>
						<div className="placeholder">
							{isRequired && <span className="isrequired-label">*</span>}
							{placeholder}
						</div>
						{displayText && <div className="upload-input">{displayText}</div>}
						<FileUploader
							hidden
							accept="image/*"
							name="avatar"
							filename={this.fileNamer}
							storageRef={firebase.storage().ref(this.state.appId)}
							onUploadStart={this.handleUploadStart}
							onUploadError={this.handleUploadError}
							onUploadSuccess={this.handleUploadSuccess}
							onProgress={this.handleProgress}
						/>
						{error && <small className="error-message">{error}</small>}
					</div>
				</label>
			</Fragment>
		);
	}
}

FileManager.propTypes = {
	actions: PropTypes.object,
	apps: PropTypes.array,
	error: PropTypes.any,
	field: PropTypes.string,
	id: PropTypes.string,
	isRequired: PropTypes.bool,
	placeholder: PropTypes.string,
	removeFile: PropTypes.func,
	type: PropTypes.string,
	uploadError: PropTypes.func,
	uploadSuccess: PropTypes.func,
	value: PropTypes.any,
};

const mapStateToProps = state => ({
	apps: state.apps.apps,
});

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(globalActions, dispatch),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(FileManager);
